"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteFooterTablet = void 0;

var _react = _interopRequireDefault(require("react"));

var _box = _interopRequireDefault(require("@waglabs/box"));

var _flex = _interopRequireDefault(require("@waglabs/flex"));

var _icon = _interopRequireDefault(require("@waglabs/icon"));

var _Divider = require("./Divider");

var _FooterCopyrightText = require("./FooterCopyrightText");

var _FooterDownloadAppText = require("./FooterDownloadAppText");

var _FooterHelpCenterLink = require("./FooterHelpCenterLink");

var _FooterLink = require("./FooterLink");

var _FooterLinksGroup = require("./FooterLinksGroup");

var _FooterSocialIconLinks = require("./FooterSocialIconLinks");

var _SiteFooterAppStoreLink = require("./SiteFooterAppStoreLink");

var _SiteFooterGooglePlayLink = require("./SiteFooterGooglePlayLink");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SiteFooterTablet = function SiteFooterTablet(props) {
  var data = props.data,
      rest = _objectWithoutProperties(props, ["data"]);

  var aboutWagLinks = data.aboutWagLinks,
      legalLinks = data.legalLinks,
      lifestyleLinks = data.lifestyleLinks,
      resourcesLinks = data.resourcesLinks,
      securityLinks = data.securityLinks,
      topWagCitiesLinks = data.topWagCitiesLinks;
  return _react["default"].createElement(_box["default"], _extends({
    bg: "backgroundGray",
    boxSizing: "border-box",
    pb: "32px",
    pt: "56px",
    px: "32px",
    width: 1
  }, rest), _react["default"].createElement(_flex["default"], null, _react["default"].createElement(_flex["default"], {
    flex: 4,
    flexDirection: "column"
  }, _react["default"].createElement(_icon["default"], {
    mb: "24px",
    name: "wagTextLogo",
    width: "112px"
  }), _react["default"].createElement(_FooterHelpCenterLink.FooterHelpCenterLink, {
    mb: "40px"
  }), _react["default"].createElement(_SiteFooterAppStoreLink.SiteFooterAppStoreLink, {
    mb: "16px"
  }), _react["default"].createElement(_SiteFooterGooglePlayLink.SiteFooterGooglePlayLink, {
    mb: "32px"
  }), _react["default"].createElement(_FooterDownloadAppText.FooterDownloadAppText, {
    mb: "96px"
  }), _react["default"].createElement(_FooterSocialIconLinks.FooterSocialIconLinks, null)), _react["default"].createElement(_flex["default"], {
    flex: 2,
    flexDirection: "column"
  }, _react["default"].createElement(_FooterLinksGroup.FooterLinksGroup, {
    data: {
      links: aboutWagLinks
    },
    mb: "32px",
    title: "About Wag!"
  }), _react["default"].createElement(_FooterLinksGroup.FooterLinksGroup, {
    data: {
      links: resourcesLinks
    },
    title: "Resources"
  })), _react["default"].createElement(_flex["default"], {
    flexDirection: "column",
    flex: 2
  }, _react["default"].createElement(_FooterLinksGroup.FooterLinksGroup, {
    data: {
      links: topWagCitiesLinks
    },
    mb: "32px",
    title: "Top Wag! cities"
  }), _react["default"].createElement(_FooterLinksGroup.FooterLinksGroup, {
    data: {
      links: lifestyleLinks
    },
    mb: "32px",
    title: "Lifestyles"
  }), _react["default"].createElement(_FooterLinksGroup.FooterLinksGroup, {
    data: {
      links: securityLinks
    },
    title: "Security"
  }))), _react["default"].createElement(_Divider.Divider, {
    mb: "32px",
    mt: "40px"
  }), _react["default"].createElement(_flex["default"], {
    alignItems: "center"
  }, _react["default"].createElement(_FooterCopyrightText.FooterCopyrightText, {
    style: {
      flex: 4
    }
  }), _react["default"].createElement(_flex["default"], {
    alignItems: "center",
    flex: 4
  }, legalLinks.map(function (_ref) {
    var url = _ref.url,
        label = _ref.label;
    return _react["default"].createElement(_FooterLink.FooterLink, {
      key: label,
      href: url,
      style: {
        flex: 2
      }
    }, label);
  }))));
};

exports.SiteFooterTablet = SiteFooterTablet;